import { useShoppingCart } from '../../contexts/ShoppingContext';

const ProductAddToCart = ({ product }) => {
  const { cart, addToCart, removeFromCart } = useShoppingCart();
  const quantity = cart[product.id] || 0;

  const handleClick = (e, action) => {
    e.preventDefault(); // Prevent Link navigation
    if (action === 'add') {
      addToCart(product);
    } else {
      removeFromCart(product);
    }
  };

  if (quantity === 0) {
    return (
      <button
        onClick={(e) => handleClick(e, 'add')}
        className="text-primary-600 hover:text-primary-700 border-2 border-primary-600 p-2 rounded-full transition-colors"
      >
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
          />
        </svg>
      </button>
    );
  }

  return (
    <div className="flex items-center space-x-2">
      <button
        onClick={(e) => handleClick(e, 'remove')}
        className="bg-primary-600 text-white p-1 rounded-full hover:bg-primary-700 transition-colors"
      >
        <svg
          className="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M20 12H4"
          />
        </svg>
      </button>
      <span className="font-medium">{quantity}</span>
      <button
        onClick={(e) => handleClick(e, 'add')}
        className="text-primary-600 hover:text-primary-700 border-2 border-primary-600 p-2 rounded-full transition-colors"
      >
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
          />
        </svg>
      </button>
    </div>
  );
};

export default ProductAddToCart;
